namespace Portico.Models.Enterprise {
    export interface IJanssenGECheck {
        tcProgramId: number;
        ndc: string;
        firstName: string;
        lastName: string;
        gender: string;
        dateOfBirth: string;
        addressLine1: string;
        city: string;
        state: string;
        zipCode: string;
        uniqueId: string;
        memberNumber: string;
    }

    export class JanssenGECheck implements IJanssenGECheck {
        tcProgramId: number;
        ndc: string;
        firstName: string;
        lastName: string;
        gender: string;
        dateOfBirth: string;
        addressLine1: string;
        city: string;
        state: string;
        zipCode: string;
        uniqueId: string;
        memberNumber: string;

        constructor(obj?: IJanssenGECheck) {
            this.tcProgramId = null;
            this.ndc = null
            this.firstName = null;
            this.lastName = null;
            this.gender = null;
            this.dateOfBirth = null;
            this.addressLine1 = null;
            this.city = null;
            this.state = null;
            this.zipCode = null;
            this.uniqueId = null;
            this.memberNumber = null;

            if (obj) {
                this.tcProgramId = obj.tcProgramId;
                this.ndc = obj.ndc;
                this.firstName = obj.firstName;
                this.lastName = obj.lastName;
                this.gender = obj.gender;
                this.dateOfBirth = obj.dateOfBirth;
                this.addressLine1 = obj.addressLine1;
                this.city = obj.city;
                this.state = obj.state;
                this.zipCode = obj.zipCode;
                this.uniqueId = obj.uniqueId;
                this.memberNumber = obj.memberNumber;
            }
        }
    }
}